import * as React from "react";

import { createSvgIcon } from "@mui/material/utils";

const Achievement9Icon = createSvgIcon(
    <svg
        width="160"
        height="160"
        viewBox="0 0 160 160"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M10 94.7326V26C10 22.6863 12.6863 20 16 20H43.3866C44.4434 20 45.4815 19.7209 46.3958 19.1908L76.5124 1.73197C78.3619 0.659779 80.6422 0.652688 82.4984 1.71335L113.117 19.2095C114.023 19.7275 115.049 20 116.093 20H143C146.314 20 149 22.6863 149 26V94.7326C149 111.552 139.821 127.03 125.062 135.097L82.3777 158.427C80.5844 159.407 78.4156 159.407 76.6223 158.427L33.9378 135.097C19.1794 127.03 10 111.552 10 94.7326Z"
            fill="url(#paint0_linear_5305_1618)"
        />
        <g filter="url(#filter0_i_5305_1618)">
            <path
                d="M23 95.1528V37.25C23 33.9363 25.6863 31.25 29 31.25H50.3598C51.4336 31.25 52.4877 30.9618 53.4121 30.4156L76.5271 16.7567C78.3675 15.6692 80.6476 15.643 82.5125 16.688L107.133 30.4843C108.029 30.9863 109.039 31.25 110.066 31.25H130C133.314 31.25 136 33.9363 136 37.25V95.1528C136 106.856 129.611 117.625 119.341 123.236L82.3764 143.429C80.5838 144.408 78.4162 144.408 76.6236 143.429L39.659 123.236C29.3885 117.625 23 106.856 23 95.1528Z"
                fill="url(#paint1_linear_5305_1618)"
            />
        </g>
        <path
            d="M23 95.1528V37.25C23 33.9363 25.6863 31.25 29 31.25H50.3598C51.4336 31.25 52.4877 30.9618 53.4121 30.4156L76.5271 16.7567C78.3675 15.6692 80.6476 15.643 82.5125 16.688L107.133 30.4843C108.029 30.9863 109.039 31.25 110.066 31.25H130C133.314 31.25 136 33.9363 136 37.25V95.1528C136 106.856 129.611 117.625 119.341 123.236L82.3764 143.429C80.5838 144.408 78.4162 144.408 76.6236 143.429L39.659 123.236C29.3885 117.625 23 106.856 23 95.1528Z"
            stroke="url(#paint2_linear_5305_1618)"
            strokeWidth="3"
        />
        <g filter="url(#filter1_d_5305_1618)">
            <path
                d="M58.2065 75.634C58.9402 74.1475 61.0598 74.1475 61.7935 75.634L65.4125 82.9669C65.7038 83.5572 66.267 83.9664 66.9184 84.061L75.0108 85.2369C76.6512 85.4753 77.3063 87.4912 76.1192 88.6483L70.2635 94.3562C69.7921 94.8157 69.577 95.4777 69.6883 96.1265L71.0707 104.186C71.3509 105.82 69.636 107.066 68.1688 106.295L60.9307 102.489C60.348 102.183 59.652 102.183 59.0693 102.489L51.8312 106.295C50.364 107.066 48.6491 105.82 48.9293 104.186L50.3117 96.1265C50.423 95.4777 50.2079 94.8157 49.7365 94.3562L43.8808 88.6483C42.6937 87.4912 43.3488 85.4753 44.9892 85.2369L53.0816 84.061C53.733 83.9664 54.2962 83.5572 54.5875 82.9669L58.2065 75.634Z"
                fill="#F5E65F"
            />
            <path
                d="M58.8789 75.9658C59.3088 75.0948 60.5004 75.0404 61.0254 75.8027L61.1211 75.9658L64.7402 83.2988C65.1158 84.0598 65.8198 84.6015 66.6445 84.7734L66.8105 84.8037L74.9033 85.9795C75.8642 86.1194 76.284 87.235 75.7217 87.9697L75.5957 88.1113L69.7402 93.8193C69.1326 94.4116 68.8346 95.2485 68.9258 96.0859L68.9492 96.2529L70.3311 104.313C70.4949 105.27 69.5639 106.015 68.6914 105.707L68.5176 105.631L61.2793 101.825C60.5283 101.431 59.6401 101.406 58.8721 101.751L58.7207 101.825L51.4824 105.631C50.6226 106.083 49.6269 105.426 49.6504 104.501L49.6689 104.313L51.0508 96.2529C51.1941 95.4165 50.9431 94.5642 50.377 93.9404L50.2598 93.8193L44.4043 88.1113C43.7088 87.4334 44.025 86.2834 44.9121 86.0195L45.0967 85.9795L53.1895 84.8037C54.0291 84.6817 54.7622 84.1792 55.1807 83.4482L55.2598 83.2988L58.8789 75.9658Z"
                stroke="#E69614"
                strokeWidth="1.5"
            />
        </g>
        <g filter="url(#filter2_d_5305_1618)">
            <path
                d="M78.2065 41.634C78.9402 40.1475 81.0598 40.1475 81.7935 41.634L85.4125 48.9669C85.7038 49.5572 86.267 49.9664 86.9184 50.061L95.0108 51.2369C96.6512 51.4753 97.3063 53.4912 96.1192 54.6483L90.2635 60.3562C89.7921 60.8157 89.577 61.4777 89.6883 62.1265L91.0707 70.1862C91.3509 71.82 89.636 73.066 88.1688 72.2946L80.9307 68.4893C80.348 68.183 79.652 68.183 79.0693 68.4893L71.8312 72.2946C70.364 73.066 68.6491 71.82 68.9293 70.1862L70.3117 62.1265C70.423 61.4777 70.2079 60.8157 69.7365 60.3562L63.8808 54.6483C62.6937 53.4912 63.3488 51.4753 64.9892 51.2369L73.0816 50.061C73.733 49.9664 74.2962 49.5572 74.5875 48.9669L78.2065 41.634Z"
                fill="#F5E65F"
            />
            <path
                d="M78.8789 41.9658C79.3088 41.0948 80.5004 41.0404 81.0254 41.8027L81.1211 41.9658L84.7402 49.2988C85.1158 50.0598 85.8198 50.6015 86.6445 50.7734L86.8105 50.8037L94.9033 51.9795C95.8642 52.1194 96.284 53.235 95.7217 53.9697L95.5957 54.1113L89.7402 59.8193C89.1326 60.4116 88.8346 61.2485 88.9258 62.0859L88.9492 62.2529L90.3311 70.3135C90.4949 71.2705 89.5639 72.0146 88.6914 71.707L88.5176 71.6309L81.2793 67.8252C80.5283 67.4305 79.6401 67.4055 78.8721 67.751L78.7207 67.8252L71.4824 71.6309C70.6226 72.0829 69.6269 71.4264 69.6504 70.501L69.6689 70.3135L71.0508 62.2529C71.1941 61.4165 70.9431 60.5642 70.377 59.9404L70.2598 59.8193L64.4043 54.1113C63.7088 53.4334 64.025 52.2834 64.9121 52.0195L65.0967 51.9795L73.1895 50.8037C74.0291 50.6817 74.7622 50.1792 75.1807 49.4482L75.2598 49.2988L78.8789 41.9658Z"
                stroke="#E69614"
                strokeWidth="1.5"
            />
        </g>
        <g filter="url(#filter3_d_5305_1618)">
            <path
                d="M98.2065 75.634C98.9402 74.1475 101.06 74.1475 101.793 75.634L105.413 82.9669C105.704 83.5572 106.267 83.9664 106.918 84.061L115.011 85.2369C116.651 85.4753 117.306 87.4912 116.119 88.6483L110.264 94.3562C109.792 94.8157 109.577 95.4777 109.688 96.1265L111.071 104.186C111.351 105.82 109.636 107.066 108.169 106.295L100.931 102.489C100.348 102.183 99.652 102.183 99.0693 102.489L91.8312 106.295C90.364 107.066 88.6491 105.82 88.9293 104.186L90.3117 96.1265C90.423 95.4777 90.2079 94.8157 89.7365 94.3562L83.8808 88.6483C82.6937 87.4912 83.3488 85.4753 84.9892 85.2369L93.0816 84.061C93.733 83.9664 94.2962 83.5572 94.5875 82.9669L98.2065 75.634Z"
                fill="#F5E65F"
            />
            <path
                d="M98.8789 75.9658C99.3088 75.0948 100.5 75.0404 101.025 75.8027L101.121 75.9658L104.74 83.2988C105.116 84.0598 105.82 84.6015 106.645 84.7734L106.811 84.8037L114.903 85.9795C115.864 86.1194 116.284 87.235 115.722 87.9697L115.596 88.1113L109.74 93.8193C109.133 94.4116 108.835 95.2485 108.926 96.0859L108.949 96.2529L110.331 104.313C110.495 105.27 109.564 106.015 108.691 105.707L108.518 105.631L101.279 101.825C100.528 101.431 99.6401 101.406 98.8721 101.751L98.7207 101.825L91.4824 105.631C90.6226 106.083 89.6269 105.426 89.6504 104.501L89.6689 104.313L91.0508 96.2529C91.1941 95.4165 90.9431 94.5642 90.377 93.9404L90.2598 93.8193L84.4043 88.1113C83.7088 87.4334 84.025 86.2834 84.9121 86.0195L85.0967 85.9795L93.1895 84.8037C94.0291 84.6817 94.7622 84.1792 95.1807 83.4482L95.2598 83.2988L98.8789 75.9658Z"
                stroke="#E69614"
                strokeWidth="1.5"
            />
        </g>
        <defs>
            <filter
                id="filter0_i_5305_1618"
                x="21.5"
                y="14.4223"
                width="120"
                height="135.241"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="BackgroundImageFix"
                    result="shape"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="4" dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                />
                <feBlend
                    mode="normal"
                    in2="shape"
                    result="effect1_innerShadow_5305_1618"
                />
            </filter>
            <filter
                id="filter1_d_5305_1618"
                x="38.2747"
                y="68.5191"
                width="45.4507"
                height="44.0096"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="1" />
                <feGaussianBlur stdDeviation="3" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_5305_1618"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_5305_1618"
                    result="shape"
                />
            </filter>
            <filter
                id="filter2_d_5305_1618"
                x="58.2747"
                y="34.5191"
                width="45.4507"
                height="44.0096"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="1" />
                <feGaussianBlur stdDeviation="3" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_5305_1618"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_5305_1618"
                    result="shape"
                />
            </filter>
            <filter
                id="filter3_d_5305_1618"
                x="78.2747"
                y="68.5191"
                width="45.4507"
                height="44.0096"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="1" />
                <feGaussianBlur stdDeviation="3" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_5305_1618"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_5305_1618"
                    result="shape"
                />
            </filter>
            <linearGradient
                id="paint0_linear_5305_1618"
                x1="10"
                y1="0"
                x2="168.978"
                y2="141.565"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#FBE865" />
                <stop offset="1" stopColor="#F1A718" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_5305_1618"
                x1="23"
                y1="15"
                x2="151.734"
                y2="126.899"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#FFE33D" />
                <stop offset="1" stopColor="#E1980D" />
            </linearGradient>
            <linearGradient
                id="paint2_linear_5305_1618"
                x1="136"
                y1="145"
                x2="23"
                y2="15"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#E69614" />
                <stop offset="1" stopColor="#E69614" stopOpacity="0" />
            </linearGradient>
        </defs>
    </svg>,
    "Achievement9Icon",
);

export default Achievement9Icon;
